export enum CleverTapConstants {
  DESKWEB = "DESKWEB",
  MOBWEB = "MOBWEB",
  APP = "APP",
  WEB = "WEB",
  DEVICEAPP = "3IN1",
}
